export class SendTitleService {
  constructor(httpClient) {
    this.httpClient = httpClient
  }

  async handle(data) {
    return await this.httpClient.post('/v01/Titulo/EnvioBoleto', data)
  }
}
